export { StatsTab } from './stats-tab';
export { AbilitiesTab } from './abilities-tab';
export { MovesTab } from './moves-tab';
export { AboutTab } from './about-tab';
export { EvolutionTab } from './evolution-tab'; 